import { conditionPriorToTypeDefinitionApi, entityOrderApi } from 'app/services/api';

import { OrderEntityType } from 'constants/orderEntityType';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PRIOR_TO_ACTION_TYPE = createNamedActions('priorTo', {
  GET_PRIOR_TO_TYPES: 'GET_PRIOR_TO_TYPES',
  ADD_PRIOR_TO_TYPE: 'ADD_PRIOR_TO_TYPE',
  UPDATE_PRIOR_TO_TYPE: 'UPDATE_PRIOR_TO_TYPE',
  DELETE_PRIOR_TO_TYPE: 'DELETE_PRIOR_TO_TYPE',
  REORDER_PRIOR_TO_TYPES: 'REORDER_PRIOR_TO_TYPES',
});

export const getPriorToTypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await conditionPriorToTypeDefinitionApi.getConditionPriorToTypeDefinitions();

  return dispatch({
    type: PRIOR_TO_ACTION_TYPE.GET_PRIOR_TO_TYPES,
    payload: data ?? [],
  });
});

export const addPriorToTypeAction = catchAsyncActionError(body => async dispatch => {
  const { data } =
    await conditionPriorToTypeDefinitionApi.createConditionPriorToTypeDefinition(body);

  return dispatch({
    type: PRIOR_TO_ACTION_TYPE.ADD_PRIOR_TO_TYPE,
    payload: data,
  });
});

export const updatePriorToTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } =
    await conditionPriorToTypeDefinitionApi.updateConditionPriorToTypeDefinition(params);

  return dispatch({
    type: PRIOR_TO_ACTION_TYPE.UPDATE_PRIOR_TO_TYPE,
    payload: data,
  });
});

export const deletePriorToTypeAction = catchAsyncActionError(
  ({ priorToTypeId, reassignToId }) =>
    async dispatch => {
      await conditionPriorToTypeDefinitionApi.deleteConditionPriorToTypeDefinition({
        priorToTypeId,
        reassignToId,
      });

      return dispatch({
        type: PRIOR_TO_ACTION_TYPE.DELETE_PRIOR_TO_TYPE,
        payload: priorToTypeId,
      });
    },
);

export const reorderPriorToTypesAction = catchAsyncActionError(
  ({ orderedEntityIds }) =>
    async dispatch => {
      dispatch({
        type: PRIOR_TO_ACTION_TYPE.REORDER_PRIOR_TO_TYPES,
        payload: orderedEntityIds,
      });

      return entityOrderApi.createOrder({
        orderedEntityType: OrderEntityType.CONDITION_PRIOR_TO_TYPE,
        orderedEntityIds,
      });
    },
);
